// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__33zgl","inputWrap":"CustomTip_inputWrap__3FIha"};